import { taxInformationSchema } from './schema.js';
import { z } from 'zod';

export type TaxType = z.infer<typeof taxInformationSchema>['taxType'];

export const isValidTaxType = (taxType: string): taxType is TaxType => {
  return ['EIN', 'GST', 'HST', 'OTHER', 'PST', 'VAT'].includes(taxType);
};
